import React from 'react';

import ProjectGeneritItemPlacehoder from './project-generic-item.placeholder';

const Placeholder = props => {
    return (
        <div className="project-generic-list">
            <ProjectGeneritItemPlacehoder key={1} />

            <ProjectGeneritItemPlacehoder key={2} />

            <ProjectGeneritItemPlacehoder key={3} />

            <ProjectGeneritItemPlacehoder key={4} />

            <ProjectGeneritItemPlacehoder key={5} />

            <ProjectGeneritItemPlacehoder key={6} />

            <ProjectGeneritItemPlacehoder key={7} />

            <ProjectGeneritItemPlacehoder key={8} />
        </div>
    )
}

export default Placeholder;
